import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import ingredientRiskComponent from './ingredient-risk.component';
import ingredientRiskService from './ingredient-risk.service';

export default
  angular.module('components.reports.ingredient-risk', [
    uiRouter
  ])
    .component('ingredientRiskReport', ingredientRiskComponent)
    .service('IngredientRiskService', ingredientRiskService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('ingredientRisk', {
          parent: 'reports',
          url: '/ingredient-risk',
          component: 'ingredientRiskReport',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/ingredient-risk/ingredient-risk.module.js